import { render, staticRenderFns } from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=template&id=214d9aec&scoped=true&lang=pug"
import script from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=script&lang=js"
export * from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=script&lang=js"
import style0 from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=style&index=0&id=214d9aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d9aec",
  null
  
)

export default component.exports